<template>
  <div class="header">
    Quartz Scheduler Monitoring
  </div>
</template>

<script>
  export default {
    name: "Header"
  }
</script>

<style scoped>
  .header {
    background-color: #343a40;
    color: #FFFFFF;
    text-align: center;
    line-height: 60px;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
</style>
